(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
<!-- section only -->
  document.addEventListener('shopify:section:load', function(event) {
    addSlideClass();
    showSlides();
<!-- 	console.log("onload!"); -->
  });

  } catch(e) { console.error(e); }
})();

})();
